import {
  MediaAssetRow,
  MediaAssetRowProps,
} from "design-system/components/blocks/media-asset-row/media-asset-row";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { MediaAssetRowEntry } from "frontend/contentful/schema/blocks";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { createRichMediaAssetProps } from "../primitives/media-asset.props";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";

interface MediaAssetRowOptions {
  headerAbove?: boolean;
}

export const ContentfulMediaAssetRow = createContentfulComponent<
  MediaAssetRowEntry,
  MediaAssetRowOptions
>(({ entry, options, createEditAttributes }) => {
  const headerAbove = options?.headerAbove || false;

  const props: MediaAssetRowProps = {
    assets: [],
    align: entry.fields.alignment!,
    header: createComponentHeaderProps(entry.fields.header),
    HeadingLevel: headerAbove ? "h3" : "h2",
    caption: <RenderContentfulRichText document={entry.fields.caption} />,
    isVerticalImages: entry.fields.isVerticalImages,
    editAttributes: {
      caption: createEditAttributes({ entry, fieldId: "caption" }),
    },
  };

  entry.fields.media?.forEach((media) => {
    const assetProps = createRichMediaAssetProps(media);
    if (assetProps) {
      // disable alignment for the row
      if (assetProps.image) assetProps.image.align = undefined;

      props.assets?.push(assetProps);
    }
  });

  return <MediaAssetRow {...props} />;
});
